import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { Container, Paper, Stack, Title, Text, Loader, Alert } from "@mantine/core";
import ExperienceBookingStepper from "./ExperienceBookingStepper";
import { ExperienceInitResponseDto } from "./types";
import { MantineProvider } from "@mantine/core";


export default function ExperienceBookingPage() {
    const [params] = useSearchParams();
    const token = params.get("token") ?? "";

    const [data, setData] = useState<ExperienceInitResponseDto | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const run = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                setLoading(true);
                setError(null);



                const res = await axios.get(`${apiUrl}/api/experience/booking/init`, {
                    params: { token },
                });
                setData(res.data);
            } catch (e: any) {
                setError(e?.response?.data ?? "Kunne ikke indl�se experience-booking.");
            } finally {
                setLoading(false);
            }
        };

        if (!token) {
            setError("Mangler token i linket.");
            setLoading(false);
            return;
        }
        run();
    }, [token]);

    if (loading) {
        return (
            <Container size="sm" py="xl">
                <Paper withBorder p="lg">
                    <Stack>
                        <Loader />
                        <Text>Indl�ser�</Text>
                    </Stack>
                </Paper>
            </Container>
        );
    }

    if (error || !data) {
        return (
            <Container size="sm" py="xl">
                <Alert color="red" title="Fejl">
                    {error ?? "Ukendt fejl"}
                </Alert>
            </Container>
        );
    }

    return (
        <Container size="md" py="xl">
            <Paper withBorder p="lg" radius="md">
                <Stack gap="xs">
                    <Title order={3}>Experience order</Title>
                    <Text c="dimmed">
                        <Text c="dimmed">
                            {(data?.person?.name ?? "�")} � {(data?.event?.name ?? "�")}
                        </Text>
                    </Text>
                </Stack>
            </Paper>

            <Paper withBorder p="lg" radius="md" mt="md">
                <MantineProvider
                    theme={{
                        primaryColor: "brand",
                        colors: {
                            brand: [
                                "#ffe5e5",
                                "#ffcaca",
                                "#ff9a9a",
                                "#ff7a7a",
                                "#ff6868",
                                "#ff5e5e",
                                "#f24848",
                                "#e53a3a",
                                "#d92d2d",
                                "#cc2222",
                            ],
                        },
                    }}
                >
                    <ExperienceBookingStepper init={data} token={token} />
                </MantineProvider>
            </Paper>
        </Container>
    );
}